import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import { ArrowLeft, Calendar, Tag } from 'lucide-react';
import blogPosts from '../data/blogPosts';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  // Generate JSON-LD Article Schema
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "image": [
      `https://fastinvoice.in${post.image}` // Placeholder absolute URL
    ],
    "datePublished": new Date(post.date).toISOString(),
    "dateModified": new Date(post.date).toISOString(),
    "author": [{
      "@type": "Organization",
      "name": "FastInvoice",
      "url": "https://fastinvoice.in"
    }],
    "description": post.excerpt
  };

  return (
    <article className="blog-post-page">
      <SEO 
        title={post.title}
        description={post.excerpt}
        schema={articleSchema}
      />
      
      <div className="blog-post-container">
        <Link to="/blog" className="back-link">
          <ArrowLeft size={16} /> Back to Blog
        </Link>
        
        <header className="post-header">
          <div className="post-meta">
            <span className="meta-tag"><Tag size={14} /> {post.category}</span>
            <span className="meta-date"><Calendar size={14} /> {post.date}</span>
          </div>
          <h1 className="post-title">{post.title}</h1>
          <p className="post-excerpt">{post.excerpt}</p>
        </header>

        <div className="post-hero-image">
          <img src={post.image} alt={post.title} />
        </div>

        <div className="post-body">
          {post.content}
        </div>
      </div>
      
      <Footer />
    </article>
  );
};

export default BlogPost;
